/**
 * V69 — 휴가 유형 자격 필터 (FE 공용 SSoT)
 *
 * MyLeavePage / WorkMyApprovalsPage 등 휴가 신청 dropdown 에서 동일 자격 필터 적용.
 * BE createLeaveRequest 가드와 정책 일치.
 *
 * 매트릭스:
 *   - personalHealing: CN REGULAR 만 사용 가능 (CN 비정규직 차단)
 *   - womenday: CN REGULAR + gender='female' 만 (CN 정규직 남성/null/empty/other 차단)
 *   - birthday / healthcn: CN REGULAR 만 (CN 비정규직 차단)
 *   - 위 4종 모두 KR 자동 차단 (visibilityScope='CN' 자연 차단 + KR 안전망)
 */

export const CN_SPECIAL_LEAVE_CODES = new Set(['womenday', 'birthday', 'healthcn']);

export interface UserEligibilityContext {
  companyCode?: 'KR' | 'CN' | string | null;
  currentEmploymentTypeCode?: string | null;
  gender?: string | null;
}

/**
 * leaveTypes 목록을 user 자격에 맞춰 필터.
 * @param leaveTypes useLeaveTypes 응답 그대로
 * @param ctx { companyCode, currentEmploymentTypeCode, gender }
 */
export function filterVisibleLeaveTypes<T extends { code: string }>(
  leaveTypes: T[],
  ctx: UserEligibilityContext,
): T[] {
  const cc = ctx.companyCode;
  const etc = ctx.currentEmploymentTypeCode;
  const gender = ctx.gender;
  const isCnNonRegular = cc === 'CN' && etc !== 'REGULAR';
  const isCnRegularNotFemale = cc === 'CN' && etc === 'REGULAR' && gender !== 'female';
  const isCnNonRegularForPH = isCnNonRegular;

  return leaveTypes.filter((lt) => {
    const code = lt.code as string;
    // V68: CN 비정규직 → personalHealing 미노출
    if (isCnNonRegularForPH && code === 'personalHealing') return false;
    // V69: KR 안전망 (visibilityScope 도 차단하지만 명시적 가드)
    if (cc !== 'CN' && CN_SPECIAL_LEAVE_CODES.has(code)) return false;
    // V69: CN 비정규직 → CN 특수휴가 3종 모두 미노출
    if (CN_SPECIAL_LEAVE_CODES.has(code) && isCnNonRegular) return false;
    // V69: CN 정규직 남성/null/empty/other → womenday 미노출
    if (code === 'womenday' && isCnRegularNotFemale) return false;
    return true;
  });
}
